export default "__VITE_ASSET__ZB8AfoXr__"